'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'country', 'CountryService', 'StatusService',
    function ($scope, $modalInstance, country, CountryService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        // инициализация
        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.country = angular.copy(country);

            if (country == null || angular.equals({}, country) || country.id == null) {
                $scope.title = "Создание новой страны";
            } else {
                $scope.title = 'Редактирование страны "' + $scope.country.name + '"';
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.country.status) {
                    $scope.country.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.country);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                CountryService.api.isUniqueName({name: name, id: $scope.country.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else $scope.uniqueLogin = true;
        }

        // endregion

    }];